function animateNumber(element, duration) {
    let finalNumber = parseInt(element.getAttribute('data-number'), 10); // Estrai il numero finale dall'attributo 'data-number'
    let currentNumber = 0;
    let startTime = null;

    function updateNumber(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsedTime = timestamp - startTime;
        const progress = Math.min(elapsedTime / duration, 1);

        // Calcola il numero corrente da visualizzare
        currentNumber = Math.floor(progress * finalNumber);
        element.textContent = currentNumber;

        // Continua l'animazione fino a quando non si raggiunge il tempo desiderato
        if (progress < 1) {
            requestAnimationFrame(updateNumber);
        }
    }

    requestAnimationFrame(updateNumber);
}

function createObserver() {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Avvia l'animazione per ogni elemento .msx-number visibile
                animateNumber(entry.target, 1000); // Ad esempio, anima in 2 secondi
                observer.unobserve(entry.target); // Opzionale: smette di osservare dopo l'animazione
            }
        });
    }, {
        threshold: 0.5 // Avvia l'animazione quando almeno il 50% dell'elemento è visibile
    });

    // Osserva tutti gli elementi con classe .msx-number
    document.querySelectorAll('.msx-number').forEach(element => {
        observer.observe(element);
    });
}

// Avvia l'observer quando il documento è pronto
document.addEventListener('DOMContentLoaded', createObserver);
